const ButtonLarge = ({
   children,
   additionalClass,
   ...buttonProps
}) => <button className={`button-large ${additionalClass}`} {...buttonProps}>{children}</button>;

export default ButtonLarge;
